import {Component, Input, OnInit, ElementRef, Renderer2, ViewEncapsulation} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-inline-svg',
    template: '',
    styleUrls: ['./inline-svg.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InlineSvgComponent implements OnInit {
    @Input() file: string;
    @Input() cssClass: string;

    constructor(private http: HttpClient,
                private el: ElementRef,
                private renderer: Renderer2,
                private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.loadSvg();
    }

    loadSvg() {
        this.http.get(this.file, { responseType: 'text' }).subscribe(data => {
            const svgElement = this.renderer.createElement('div');
            this.renderer.setProperty(svgElement, 'innerHTML', data);
            const svg = svgElement.querySelector('svg');
            if (this.cssClass) {
                this.renderer.setAttribute(svg, 'class', this.cssClass);
            }
            this.renderer.appendChild(this.el.nativeElement, svg);
        });
    }
}
